const APP_STORE_BLOCKED_ACCOUNT_IDS = new Set([2]);

export const isAppStoreAvailableForAccount = accountId =>
  !APP_STORE_BLOCKED_ACCOUNT_IDS.has(Number(accountId));
